// extracted by mini-css-extract-plugin
export default {"container":"category_container__h1fzd","header":"category_header__MvpNU"};